import Axios from "../utils/Axios";

export type detailSettingType = {
  is_detail: boolean;
}

export type pushSettingType = {
  effect: string;
  volume: number;
  order_count: number;
  infinite: boolean;
  delay: number;
}

export type deliverySettingType = {
  type: string;
  name: string;
  mode: number;
  app_call_delay: number;
}

export type PrinterSettingType = {
  id: number;
  lan_ip: string;
  lan_port: string;
  name: string;
  print_after_confirmed: boolean;
  print_count: number;
  print_customer_receipt: boolean;
  print_kitchen_receipt: boolean;
  qr_code_mode: string;
  serial_baud_rate: number;
  serial_port: string;
  serial_port_input: string;
  type: string;
  type_detail: string[];
  usb_name: string;
}

const PosController = {
  setPosConfig: async (oParams: any) => {
    try {
      let sUrl = '/pos/setPosConfig';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[POS 설정 저장하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  getPosConfig: async () => {
    try {
      let sUrl = '/pos/getPosConfig';
      const response: any = await Axios.post(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[POS 설정 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  posUpdateCheckFor096: async () => {
    try {
      let sUrl = '/pos/posUpdateCheckFor096';
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[POS 업데이트 여부 조회 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default PosController;
